import Icon from "@mui/material/Icon";

import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

import type { ThumbView } from "./thumb-view";
import { useSiteTranslations } from "./use-site-translations";

const VIEWS: { view: ThumbView; icon: string }[] = [
  { view: "desktop", icon: "desktop_windows" },
  { view: "mobile", icon: "smartphone" },
];

export function ThumbViewToggle({
  view,
  onChange,
}: {
  view: ThumbView;
  onChange: (view: ThumbView) => void;
}) {
  const { t } = useSiteTranslations();
  return (
    <SoftBox display="flex" gap={1} role="group" aria-label={t.designs.viewLabel}>
      {VIEWS.map((option) => {
        const active = option.view === view;
        return (
          <SoftButton
            key={option.view}
            variant={active ? "gradient" : "outlined"}
            color={active ? "dark" : "secondary"}
            size="small"
            aria-pressed={active}
            onClick={() => onChange(option.view)}
            data-testid={`ready-designs-view-${option.view}`}
          >
            <Icon sx={{ mr: 0.75 }}>{option.icon}</Icon>
            {option.view === "desktop" ? t.designs.viewDesktop : t.designs.viewMobile}
          </SoftButton>
        );
      })}
    </SoftBox>
  );
}
